(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["back-to-top"] && !Shopify.designMode) return;
  try {
    (function() {
    var btn = document.getElementById('BackToTop');
    if (!btn) return;

    var ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          if (window.scrollY > 400) {
            btn.classList.add('is-visible');
          } else {
            btn.classList.remove('is-visible');
          }
          ticking = false;
        });
        ticking = true;
      }
    });

    btn.addEventListener('click', function() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-recommendations"] && !Shopify.designMode) return;
  try {
    (function() {
    document.addEventListener('submit', function(e) {
      var form = e.target;
      if (!form.classList.contains('cart-recs__form')) return;

      e.preventDefault();
      var btn = form.querySelector('.cart-recs__add-btn');
      btn.disabled = true;
      btn.style.opacity = '0.5';

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: new FormData(form)
      })
        .then(function(r) { return r.json(); })
        .then(function() {
          return fetch(window.Shopify.routes.root + '?section_id=cart-drawer');
        })
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newDrawer = doc.getElementById('cart-drawer');
          var currentDrawer = document.getElementById('cart-drawer');
          if (newDrawer && currentDrawer) {
            currentDrawer.innerHTML = newDrawer.innerHTML;
          }
          if (window.NatureNestCarousel) {
            currentDrawer.querySelectorAll('[data-carousel-container]').forEach(function(el) {
              new window.NatureNestCarousel(el);
            });
          }
        })
        .catch(function() {
          btn.disabled = false;
          btn.style.opacity = '1';
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-toast"] && !Shopify.designMode) return;
  try {
    (function() {
    var toast = document.getElementById('CartToast');
    var toastText = document.getElementById('CartToastText');
    var toastView = document.getElementById('CartToastView');
    var hideTimer;

    window.showCartToast = function(productTitle) {
      if (!toast) return;
      if (productTitle && toastText) {
        toastText.textContent = productTitle;
      }
      clearTimeout(hideTimer);
      toast.classList.add('is-visible');
      hideTimer = setTimeout(function() {
        toast.classList.remove('is-visible');
      }, 4000);
    };

    if (toastView) {
      toastView.addEventListener('click', function() {
        clearTimeout(hideTimer);
        toast.classList.remove('is-visible');
        if (window.shopifyCart) {
          window.shopifyCart.openDrawer();
        }
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["exit-intent-popup"] && !Shopify.designMode) return;
  try {
    (function() {
    var popup = document.getElementById('ExitIntentPopup');
    if (!popup) return;

    // Don't show if already shown this session
    if (sessionStorage.getItem('nn_exit_popup_shown')) return;

    var closeBtns = popup.querySelectorAll('[data-exit-close]');
    var triggered = false;

    function showPopup() {
      if (triggered) return;
      triggered = true;
      popup.classList.add('is-active');
      popup.setAttribute('aria-hidden', 'false');
      sessionStorage.setItem('nn_exit_popup_shown', '1');
      document.body.style.overflow = 'hidden';
    }

    function closePopup() {
      popup.classList.remove('is-active');
      popup.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    // Exit intent: mouse leaves viewport toward top
    document.addEventListener('mouseleave', function(e) {
      if (e.clientY <= 0) {
        showPopup();
      }
    });

    // Close handlers
    closeBtns.forEach(function(btn) {
      btn.addEventListener('click', closePopup);
    });

    // Close on Escape
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && popup.classList.contains('is-active')) {
        closePopup();
      }
    });

    // Also show on form success (if redirected back)
    var successMsg = popup.querySelector('.exit-popup__success');
    if (successMsg) {
      showPopup();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["frequently-bought-together"] && !Shopify.designMode) return;
  try {
    (function() {
    var btn = document.querySelector('[data-fbt-add-all]');
    if (!btn) return;

    btn.addEventListener('click', function() {
      var items;
      try {
        items = JSON.parse(btn.getAttribute('data-items'));
      } catch(e) {
        return;
      }

      btn.disabled = true;
      btn.textContent = btn.textContent.replace(/./g, function(c, i) { return i < 10 ? c : ''; }) + '...';

      var formData = { items: items };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      })
      .then(function(response) { return response.json(); })
      .then(function() {
        btn.disabled = false;
        btn.textContent = '\u2713';
        setTimeout(function() {
          window.location.reload();
        }, 600);
      })
      .catch(function() {
        btn.disabled = false;
        btn.textContent = 'Error';
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
